module.exports = __webpack_public_path__ + "img/case_piggy_portrait.08d5c3ef.jpg";